import { render } from "./accident.vue?vue&type=template&id=1ab3af72&scoped=true"
import script from "./accident.vue?vue&type=script&lang=js"
export * from "./accident.vue?vue&type=script&lang=js"

import "./accident.vue?vue&type=style&index=0&id=1ab3af72&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab3af72"]])

export default __exports__